import Verified from './verified';
// export type { VerifiedProps } from './verified';
export default Verified;
